import React, { Component } from 'react'
import Button from 'components/button/button'
import { connect } from 'react-redux'

import InputStandard from 'components/input/standard'

import {
	getCurrentAccount,
	getCurrentUser,
} from 'state/selectors'

import {
	sendFeedback,
	postAnnouncement
} from 'state/actions'

import QuillWysiwyg from 'components/input/quill-wysiwyg'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

class ModalFeedback extends Component {
	// This is really confusing, but this does announcements AND feedback
	state = {
		id: null,
		title: '',
		copy: '',
		wysiwygVisible: false
	}

	isAnnouncement = false

	UNSAFE_componentWillMount = _ => {
		if (this.props.data && this.props.data.isAnnouncement) {
			this.isAnnouncement = true

			if (this.props.data.announcement) {
				const {
					announcement
				} = this.props.data

				this.setState({
					...announcement
				})
			}
		}
	}

	componentDidMount = _ => {
		setTimeout(_ => {
			this.setState({
				wysiwygVisible: true
			}, _ => {
				if (this.announcementRef) {
					this.announcementRef.inputRef.focus()
				}else{
					setTimeout(_ => {
						if (this.copyBox) {
							this.copyBox.quillRef.focus()
						}
					},1)
				}
			})
		}, 1)
	}

	handleSubmit = _ => {
		const {
			isLoading,
			setLoading,
			accountData,
			handleError,
			sendFeedback,
			postAnnouncement
		} = this.props

		const {
			title,
			copy
		} = this.state

		if (isLoading) {
			return
		}

		if (this.isAnnouncement) {
			if (!title) {
				return handleError(`You'll need to enter an announcement first!`)
			}

			postAnnouncement(this.state, accountData.id, this.handleCallback)
		} else {
			if (copy == '' || !copy || copy == ' ') {
				return handleError("You'll need to enter some feedback first!")
			}

			sendFeedback(copy, accountData.id, this.handleCallback)
		}

		setLoading(true)
	}

	handleCallback = _ => {
		const {
			setLoading,
			handleSuccess,
			closeCallback
		} = this.props

		setLoading(false)
		handleSuccess(this.isAnnouncement ? "Success! We've sent this to your staff." : "Wonderful! Thanks for letting us know.")

		setTimeout(_ => {
			closeCallback()
		}, 1000)


	}

	handleChange = (type, value) => {
		switch (type) {
			case 'copy':
				this.setState({
					copy: value
				})
				break
			case 'title':
				this.setState({
					title: this.announcementRef.inputRef.value
				})
				break
		}
	}

	generateCopy = _ => {
		if (this.isAnnouncement) {
			return {
				title: this.state.id ? 'Edit announcement' : 'Post an announcement',
				placeholder: `Add any extra details here.`
			}
		} else {
			return {
				title: 'Send feedback',
				placeholder: `What's on your mind?`
			}
		}
	}

	render() {
		const {
			closeCallback,
			handleDismiss,
			validateResponse,
		} = this.props

		const {
			wysiwygVisible
		} = this.state

		const copy = this.generateCopy()

		return (
			<div>
				<h2>
					{copy.title}
				</h2>
				<div className={'borders'}>
					{this.isAnnouncement ?
						<InputStandard
							placeholder={`What's the announcement?`}
							ref={ref => this.announcementRef = ref}
							name="title"
							onChange={_ => this.handleChange('title')}
							value={this.state.title}
						/>
						: null}
					<QuillWysiwyg
						isVisible={wysiwygVisible}
						value={this.state.copy}
						onChange={value => {this.handleChange('copy', value)}}
						canCollaborate={false}
						objectId={-1}
						availableMentions={[]}
						canEdit={true}
						placeholder={copy.placeholder}
						context="comment"
						ref={ref => this.copyBox = ref}
					/>
					<ValidateResponse
						dismissCallback={handleDismiss}
						response={validateResponse}
					/>
				</div>
				<Button
					size={'big'}
					level={'high'}
					callback={this.handleSubmit}
					label={'Submit'}
					icon={'check'}
				/>
				<Button
					size={'big'}
					level={'low'}
					callback={closeCallback}
					label={'Cancel'}
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		accountData: getCurrentAccount(state),
		userData: getCurrentUser(state),
	}
}

const ModalFeedbackWithValidateResponse = withValidateResponse(ModalFeedback)

export default connect(mapStateToProps, {
	sendFeedback,
	postAnnouncement
})(ModalFeedbackWithValidateResponse)
